export const userProfileQueryKey = (userId: string | null | undefined) => ['getUserById', userId] as const;